"use client";
import * as prismic from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";
import { PrismicNextImage, PrismicNextLink } from "@prismicio/next";
import { Button } from "@/components/Button";

export default function TastingBox({ slice }) {
  return (
    <section
      className="mx-auto py-10 p-6"
      style={{
        background: "linear-gradient(to bottom, #e4e4e4 50%, white 50%)",
      }}
    >
      <div className="flex flex-col md:flex-row bg-smoke p-4 max-w-7xl mx-auto ">
        <div className="w-full md:w-1/2 flex items-center justify-center hover:scale-[103%] transition-transform duration-300 ease-in-out">
          <PrismicNextImage field={slice.primary.image} />
        </div>
        <div className="w-full md:w-1/2 py-10 md:p-10 text-center items-center md:text-left justify-center md:justify-start">
          <h2 className="font-serif text-4xl font-normal mb-4">
            {prismic.asText(slice.primary.title)}
          </h2>
          <p className="text-base my-10 font-light text-center md:text-left lg:text-left items-center justify-center md:justify-start">
            {prismic.asText(slice.primary.description)}
          </p>
          <div className="flex items-center text-center md:text-left items-center justify-center md:justify-start gap-0">
            <span className="font-serif text-4xl font-normal bg-white px-6 py-3">
              £36
            </span>
            <Button field={slice.primary.cta_link} color="primary">
              {slice.primary.cta_link.text}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
